import React from 'react';
import Typography from 'components/Typography';
import useStyles from '../fundedInvestingManualKycDialog.styles';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { FUNDED_STEP_TEXTS, resolveFundedStepVariant } from './fundedStep.scheme';

interface StepFundedProps {
    handleNextStep: () => void;
    loading: boolean;
    isAudition?: boolean;
    isFirstAudition?: boolean;
}

const FundedStep: React.FunctionComponent<StepFundedProps> = ({
    handleNextStep,
    loading,
    isAudition,
    isFirstAudition,
}) => {
    const classes = useStyles();
    const { t } = useTranslation('prop');

    const variant = resolveFundedStepVariant(isAudition, isFirstAudition);
    const { headerKey, subTextKey, buttonKey } = FUNDED_STEP_TEXTS[variant];

    return (
        <>
            <Typography className={classes.header} variant="tLgSemibold">
                {t(headerKey)}
            </Typography>
            {!isAudition && (
                <Typography className={classes.id} variant="tSmallMedium">
                    {t('investingManualKyc.NotStarted.challengeId')}
                </Typography>
            )}
            <Typography className={classes.subTxt2} variant="tSmallRegular">
                {t(subTextKey)}
            </Typography>
            <Button
                className={classes.btn}
                variant="contained"
                color="primary"
                onClick={handleNextStep}
                loading={loading}
            >
                {t(buttonKey)}
            </Button>
        </>
    );
};

export default FundedStep;
